module.exports = __webpack_public_path__ + "img/papa-johns.643d96b5.jpg";